import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import Bugsnag from "@bugsnag/js";
import { getQueryParams } from "@/utils/httpRequest";
import { baseUrl, onPrepareHeaders } from "@/redux/services/helpers";
import {
  CONNEX_REDUCER_PATH,
  CONNEX_RELATED_TAGS,
  CONNEX_SERVICE_TAG,
} from "@/modules/contacts/features/lender/features/out-of-network/utils/connex-service-tags";
import { LIST_SERVICE_TAG } from "@/shared/store/service/commonServiceTags";

const connexService = createApi({
  reducerPath: CONNEX_REDUCER_PATH,
  tagTypes: CONNEX_RELATED_TAGS,
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: onPrepareHeaders,
  }),
  endpoints: builder => ({
    getConneXLenders: builder.query({
      query: ({ params }) => `lenders/capworks?${getQueryParams(params)}`,
      providesTags: result =>
        result
          ? [
              ...result.records.map(({ lenderId }) => ({ type: CONNEX_SERVICE_TAG, id: lenderId })),
              { type: CONNEX_SERVICE_TAG, id: LIST_SERVICE_TAG },
            ]
          : [{ type: CONNEX_SERVICE_TAG, id: LIST_SERVICE_TAG }],
      async onQueryStarted({ params, setParams }, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;

          if (!data.records.length && params.page > 1) {
            setParams(prevParams => ({ ...prevParams, page: prevParams.page - 1 }));
          }
        } catch (err) {
          Bugsnag.notify(err);
        }
      },
    }),
  }),
});

const { useGetConneXLendersQuery } = connexService;

export { CONNEX_SERVICE_TAG, useGetConneXLendersQuery, connexService };

